import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { ErrorBoundary } from '@applications/billing/components/error-boundary';
export const BillingLayoutComponent = (props) => {
    const navigate = useNavigate();
    return (
        <ErrorBoundary navigate={navigate}>
            <div className="tc-billing tc-billing-summary-page tc-page-content">
                {props.children}
            </div>
        </ErrorBoundary>
    )
}
export default BillingLayoutComponent;

